module.exports = __webpack_public_path__ + "assets/img/block-left-d775b8e7.png";